import { Stack, Typography } from "@mui/material";
import Loading from "src/components/Loading/Loading";
import SubscriptionCard from "../SubscriptionCard";
import { useGetSubscriptionsQuery } from "src/api/services/patientSubscriptionApi";
import { Trans, useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";
import { Link } from "react-router-dom";

const ActiveSubscriptions = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "subscriptions";
  const { subscriptions, isLoading } = useGetSubscriptionsQuery(undefined, {
    selectFromResult: (result) => {
      const active =
        result.data?.filter(
          (sub) =>
            sub.status !== "canceled" &&
            sub.product.billing_model !== "one_time",
        ) ?? [];
      return { subscriptions: active, isLoading: result.isLoading };
    },
  });

  return (
    <Stack gap={isMobile ? 1 : 2}>
      <Typography variant="h6" fontWeight={700}>
        {t(`${page}.subheader`, "Active")}
      </Typography>

      {isLoading ? (
        <Loading />
      ) : subscriptions.length === 0 ? (
        <Typography>
          {t(
            `${page}.no-active-subscriptions`,
            "You have no active subscriptions at the moment",
          )}
        </Typography>
      ) : (
        <>
          {subscriptions.map((sub) => (
            <SubscriptionCard key={sub.id} subscription={sub} />
          ))}
          <Trans i18nKey={`${page}.move-shipment`}>
            <Typography align="center">
              Need to move your next shipment?{" "}
              <Link to="/messaging">Message us.</Link>
            </Typography>
          </Trans>
        </>
      )}
    </Stack>
  );
};

export default ActiveSubscriptions;
